import { makeStyles } from '@mui/styles'
import { useIntl } from 'react-intl'
import { AppPageLayout } from '../../components/layouts/AppPageLayout'

import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import GroupIcon from '@mui/icons-material/Group'
import HealingIcon from '@mui/icons-material/Healing'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import { Grid, Typography } from '@mui/material'
import messages from './Dashboard.messages'
import { useDashboardState } from './Dashboard.restate'
import { DashboardTile } from './DashboardTile'

const useStyles = makeStyles({
  title: {
    width: '100%',
    textAlign: 'center',
  },
  wrapper: {
    width: '100%',
    height: '100%',
  },
  numberBox: {
    textAlign: 'center',
    margin: '100px 0',
  },
  materialIcon: {
    position: 'relative',
    fontSize: '200%',
  },
})

const Dashboard = () => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage(messages.pageTitle)
  const usersCount = intl.formatMessage(messages.usersCount)
  const mobilesCount = intl.formatMessage(messages.mobilesCount)
  const cpsCount = intl.formatMessage(messages.cpsCount)
  const trainingsCount = intl.formatMessage(messages.trainingsCount)
  const lastMonth = intl.formatMessage(messages.lastMonth)
  const usersCountRecently = intl.formatMessage(messages.usersCountRecently)
  const mobilesCountRecently = intl.formatMessage(messages.mobilesCountRecently)
  const cpsCountRecently = intl.formatMessage(messages.cpsCountRecently)

  const dashboard = useDashboardState(s => s.data)
  const classes = useStyles()

  return (
    <AppPageLayout title={pageTitle}>
      <div className={classes.wrapper}>
        <Grid container>
          <DashboardTile
            amount={dashboard.usersCount}
            description={usersCount}
            size={3}
          >
            <GroupIcon className={classes.materialIcon} />
          </DashboardTile>
          <DashboardTile
            amount={dashboard.mobilesCount}
            description={mobilesCount}
            size={3}
          >
            <PhoneAndroidIcon className={classes.materialIcon} />
          </DashboardTile>
          <DashboardTile
            amount={dashboard.cpsCount}
            description={cpsCount}
            size={3}
          >
            <FavoriteBorderIcon className={classes.materialIcon} />
          </DashboardTile>
          <DashboardTile
            amount={dashboard.trainingsCount}
            description={trainingsCount}
            size={3}
          >
            <HealingIcon className={classes.materialIcon} />
          </DashboardTile>
        </Grid>
        <Grid container>
          <Grid size={12}>
            <Typography variant={'h5'} className={classes.title}>
              {lastMonth}
              <CalendarTodayIcon className={classes.materialIcon} />
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <DashboardTile
            amount={dashboard.usersCountRecently}
            description={usersCountRecently}
            size={4}
          >
            <GroupIcon className={classes.materialIcon} />
          </DashboardTile>
          <DashboardTile
            amount={dashboard.mobilesCountRecently}
            description={mobilesCountRecently}
            size={4}
          >
            <PhoneAndroidIcon className={classes.materialIcon} />
          </DashboardTile>
          <DashboardTile
            amount={dashboard.cpsCountRecently}
            description={cpsCountRecently}
            size={4}
          >
            <FavoriteBorderIcon className={classes.materialIcon} />
          </DashboardTile>
        </Grid>
      </div>
    </AppPageLayout>
  )
}

export default Dashboard
